import React from 'react';
import './Footer.css';
import logo from '../../assets/frontend_assets/logo.png';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <div className='footer_container'>
      <div className="footer_top">
        <div className="footer_left">
          <div className="l_img">
            <img src={logo} alt="Logo" />
          </div>
          <div className="i_des">
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem magni repudiandae deleniti voluptatem recusandae autem tenetur soluta ut eaque vel? Possimus facere magni esse velit perspiciatis voluptate magnam cupiditate voluptatibus.</p>
          </div>
        </div>

        <div className="footer_right">
          <div className="r_right">
            <h2>Company</h2>
            <ul>
              <li>Home</li>
              <li>About</li>
              <li>Delivery</li>
              <li>Privacy Policy</li>
            </ul>
          </div>
          <div className="r_left">
            <h2>Get In Touch</h2>
            <ul>
              <li>0783407632</li>
              <li>charithmaneesha161@gmail.com</li>
            </ul>
          </div>
        </div>
      </div>

     <div className="footer_bottom">
  <p>
    © {year}{' '}
    <a href="https://www.charithkariyawasam.com" target="_blank" rel="noopener noreferrer">
      charithkariyawasam.com
    </a>. All rights reserved.
  </p>
</div>

    </div>
  );
}

export default Footer;
